import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';

/**
 * Wraps component by passing:
 * `finalProps` that can no longer be changed and
 * `defaultProps` that can be overridden
 */
export function defineProps(finalProps, defaultProps) {
  // eslint-disable-next-line @typescript-eslint/comma-dangle
  return function (WrappedComponent) {
    var RedefinedComponent = /*#__PURE__*/forwardRef(function (props, ref) {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, _objectSpread(_objectSpread(_objectSpread({}, defaultProps), props), finalProps), {
        ref: ref,
        "data-t-id": "src-enhancers"
      }));
    });
    if (process.env.NODE_ENV !== 'production') {
      RedefinedComponent.displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return RedefinedComponent;
  };
}